__turbopack_context__.v({
  "className": "ZdPV6W_className",
  "variable": "ZdPV6W_variable",
});
